import React from 'react';
import PropTypes from 'prop-types';

import { ToggleDot as ToggleDotElem, ToggleBg as ToggleBgElem, Input as InputElem } from './Toggle.styles';

const Toggle = ({ value, label, onToggle, checked, disabled }) => (
  <div className="my-2">
    <label
      htmlFor={value}
      className={`flex items-center u-no-tap-highlight ${disabled ? 'opacity-75' : 'cursor-pointer'}`}
    >
      <div className="relative">
        <InputElem
          id={value}
          type="checkbox"
          className="hidden"
          onChange={() => onToggle(value)}
          checked={checked}
          disabled={disabled}
        />
        <ToggleBgElem />
        <ToggleDotElem />
      </div>
      <div className="ml-3 text-basic-700">{label}</div>
    </label>
  </div>
);

Toggle.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onToggle: PropTypes.func,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
};

Toggle.defaultProps = {
  onToggle: () => {},
  checked: false,
  disabled: false,
};

export default Toggle;
